// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button___e0R7","icon":"button_icon__C3Zxw","preIcon":"button_preIcon__ysRMY"};